<section>
  <div [hidden]="loading" id="worldmap"></div>
  <mat-spinner *ngIf="loading"></mat-spinner>
</section>
